var _linearGradient;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcHomeDelivery = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.337,
    height: 33.534,
    viewBox: "0 0 44.337 33.534",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "qmx7x3wtua",
    x1: 0.473,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a1818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9b9b9b"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "if1xsgsh0b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5828",
    style: {
      fill: "url(#qmx7x3wtua)"
    },
    d: "M0 0h44.337v30.695H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2951"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2478",
    transform: "translate(-1078 -26.566)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 190",
    width: 27.313,
    height: 18.188,
    rx: 9,
    transform: "translate(1094.916 26.566)",
    style: {
      fill: "#fff4aa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2930",
    style: {
      clipPath: "url(#if1xsgsh0b)"
    },
    transform: "translate(1078 29.406)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4129",
    d: "M27.9 23.761a5.594 5.594 0 0 1 10.724-.385.471.471 0 0 0 .538.392c2.48-.012 4.961-.008 7.441 0 .248 0 .4-.02.5-.321a5.57 5.57 0 0 1 10.634.006c.032.094.07.186.109.288h2.613c.007-.163.019-.3.02-.443 0-2.1.008-4.21-.01-6.315a1.292 1.292 0 0 0-.24-.7c-.481-.665-1.011-1.294-1.5-1.956a.82.82 0 0 0-.749-.37c-3.36.013-6.72.008-10.08.008-1.207 0-1.71-.5-1.711-1.7V2.8h-21.5a3.09 3.09 0 0 1-.811-.085 1.354 1.354 0 0 1-.944-1.515A1.337 1.337 0 0 1 24.13.026 4.7 4.7 0 0 1 24.648 0q11.291 0 22.583.009a2.5 2.5 0 0 1 1.077.221 1.284 1.284 0 0 1 .671 1.223v1.343h.5c1.745 0 3.49.015 5.235-.007a1.583 1.583 0 0 1 1.575.975c.952 1.919 1.964 3.809 2.877 5.747a18.635 18.635 0 0 0 3 4.664 4.248 4.248 0 0 1 1.126 3.216c-.084 2.52-.024 5.045-.025 7.568a1.44 1.44 0 0 1-1.592 1.614q-1.752.016-3.5 0a.406.406 0 0 0-.461.323 5.571 5.571 0 0 1-10.561.009.43.43 0 0 0-.5-.333q-3.764.013-7.528 0a.456.456 0 0 0-.516.364 5.57 5.57 0 0 1-10.533.014.477.477 0 0 0-.553-.376 98.595 98.595 0 0 1-3.028 0 1.4 1.4 0 0 1-1.562-1.415 1.326 1.326 0 0 1 1.111-1.341 3.571 3.571 0 0 1 .644-.054c1.066-.005 2.132 0 3.22 0m28.898-12.618c0-.052.009-.083 0-.1-.88-1.76-1.757-3.522-2.652-5.275a.49.49 0 0 0-.374-.184c-1.527-.012-3.053-.008-4.58-.006a.951.951 0 0 0-.184.034v5.534zm-4.364 11.2a2.776 2.776 0 1 0 2.769 2.777 2.781 2.781 0 0 0-2.769-2.777m-16.328 2.789A2.782 2.782 0 1 0 33.3 27.9a2.762 2.762 0 0 0 2.812-2.766",
    transform: "translate(-18.952)",
    style: {
      fill: "url(#qmx7x3wtua)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4130",
    d: "M7.337 67.416c-1.9 0-3.8.014-5.7-.012a2.218 2.218 0 0 1-1.057-.279 1.26 1.26 0 0 1-.529-1.435 1.4 1.4 0 0 1 1.23-1.054 2.473 2.473 0 0 1 .3-.011h11.54a1.448 1.448 0 0 1 1.467.857 1.352 1.352 0 0 1-1.2 1.916c-1.469.039-2.939.017-4.408.02H7.338",
    transform: "translate(0 -53.423)",
    style: {
      fill: "url(#qmx7x3wtua)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4131",
    d: "M20.565 33.065c1.961 0 3.923-.007 5.884 0a1.349 1.349 0 0 1 1.427 1.4 1.376 1.376 0 0 1-1.458 1.379c-1.442.008-2.885 0-4.327 0-2.481 0-4.961.006-7.442 0a1.388 1.388 0 0 1-1.344-1.933 1.353 1.353 0 0 1 1.375-.847h5.884",
    transform: "translate(-10.903 -27.333)",
    style: {
      fill: "url(#qmx7x3wtua)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4132",
    d: "M17.806 96.4c1.094 0 2.189-.012 3.282.005a1.256 1.256 0 0 1 1.166.822 1.316 1.316 0 0 1-.222 1.451 1.373 1.373 0 0 1-1.1.5c-2.1 0-4.2.009-6.307 0a1.423 1.423 0 0 1-1.463-1.393A1.381 1.381 0 0 1 14.61 96.4c1.065-.018 2.131 0 3.2 0",
    transform: "translate(-10.878 -79.682)",
    style: {
      fill: "url(#qmx7x3wtua)"
    }
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcHomeDelivery);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-homeDelivery.6e1287222bd1a28b2688577024a62bcb.svg";